import {NgModule} from '@angular/core';
import {ItemVisibleDirective} from './item-visible.directive';

@NgModule({
  declarations: [ItemVisibleDirective],
  exports: [ItemVisibleDirective],
})
export class ItemVisibleModule {}
